import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const TierContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const TierRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(1),
}));

const TierLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#4A5568',
  minWidth: 60,
}));

const BarContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 8,
  backgroundColor: '#E2E8F0',
  borderRadius: 4,
  margin: '0 12px',
  overflow: 'hidden',
}));

const Bar = styled(Box)<{ width: number }>(({ theme, width }) => ({
  height: '100%',
  backgroundColor: '#6B46C1',
  width: `${width}%`,
  borderRadius: 4,
}));

const TierPercentage = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#1A202C',
  minWidth: 40,
  textAlign: 'right',
}));

const SubscriptionTiers: React.FC = () => {
  const tiers = [
    { label: 'Tier 1', percentage: 13 },
    { label: 'Tier 2', percentage: 55 },
    { label: 'Tier 3', percentage: 32 },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        Subscription Tier Breakdown
      </Typography>
      {tiers.map((tier, index) => (
        <TierContainer key={index}>
          <TierRow>
            <TierLabel>{tier.label}</TierLabel>
            <BarContainer>
              <Bar width={tier.percentage} />
            </BarContainer>
            <TierPercentage>{tier.percentage}%</TierPercentage>
          </TierRow>
        </TierContainer>
      ))}
    </Box>
  );
};

export default SubscriptionTiers; 